import { SettingsStorageMixin } from "@/services/storage/storage-mixins/settings-storage-mixin";
import { TextToMusicSettingsField } from "@/services/storage/text-to-music-session-storage";

export class TextToMusicSettingsStorageMixin extends SettingsStorageMixin<TextToMusicSettingsField> {
  protected setSettingsInternal(
    settings: any,
    value: any,
    field: TextToMusicSettingsField,
  ): void {
    settings[field] = value;
  }
}
